import { useEffect, useMemo, useState } from 'react'
import { getObjectsWithFilter } from '../../../api/apiClientCrud'
import { toast } from 'react-toastify'
import ListModule from '../../module/ListModule'
import { useAuth } from '../../../context/AuthContext'
import { useOutletContext } from 'react-router-dom'
import { getQuoteColumns } from './QuoteFields'
import Loading from '../../common/Loading'
import Quote from './Quote'
import DocumentPreview from '../../document/DocumentPreview'
import { Box } from '@mui/material'

const ListQuotes = () => {
  const [statusList, setStatusList] = useState([])
  const [customers, setCustomers] = useState([])
  const { user } = useAuth()
  const userRight = useOutletContext()

  useEffect(() => {
    const loadData = async () => {
      try {
        const [statusListRes, customersRes] = await Promise.all([
          getObjectsWithFilter('status', { object: 'quotes' }),
          getObjectsWithFilter('customers', { company_id: user.company_id })
        ])
        setStatusList(Array.isArray(statusListRes.data) ? statusListRes.data : [])
        setCustomers(Array.isArray(customersRes.data?.customers) ? customersRes.data.customers : [])
      } catch (error) {
        toast.error('Erreur lors du chargement', { autoClose: 2000 })
      }
    }

    loadData()
  }, [user.company_id])

  const columns = useMemo(() => {
    if (!statusList.length || !customers.length) return []
    return getQuoteColumns({ statusList, customers })
  }, [statusList, customers])

  const objectFilter = useMemo(() => ({ company_id: user.company_id }), [user.company_id])

  const options = useMemo(
    () => ({
      objectType: 'quotes',
      accessRight: userRight,
      objectFilter: () => objectFilter,
      actions: {
        add: true,
        edit: true,
        editDisabled: (quote) => quote.status >= 90,
        view: true,
        delete: {
          message: 'Voulez-vous vraiment supprimer le devis',
          field: 'quote_number'
        }
      },
      isFilter: true,
      isExpand: true,
      expand: (row) => <DocumentPreview Component={Quote} document={row} />,
      columns
    }),
    [userRight, user.company_id, columns]
  )

  const toolbar = useMemo(
    () => ({
      objectType: 'quotes',
      title: 'Devis',
      accessRight: userRight,
      actions: {
        add: true
      },
      columns: options.columns,
      isFilter: true,
      columnVisibility: true
    }),
    [userRight, options]
  )

  if (!columns.length)
    return (
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          height: '100%',
          minHeight: '100px',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Loading />
      </Box>
    )

  return <ListModule options={options} toolbar={toolbar} />
}

export default ListQuotes
